import { render, staticRenderFns } from "./TomaPhotos.vue?vue&type=template&id=3ba839c5&scoped=true"
import script from "./TomaPhotos.vue?vue&type=script&lang=js"
export * from "./TomaPhotos.vue?vue&type=script&lang=js"
import style0 from "./TomaPhotos.vue?vue&type=style&index=0&id=3ba839c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba839c5",
  null
  
)

export default component.exports